import InfoGrid from "../../../../../../components/info-grid/info-grid.jsx";
import {makeInitialDataItems} from "../helpers/initial-data-items.js";
import ObservationBox from "../../../../../../components/observation-box/observation-box.jsx";

export default function InitialInfo({ data, title }) {
    const initialData = makeInitialDataItems(data);
    const iniObservation = data?.garrison?.garrison_initialobservation ?? "";
    const finObservation = data?.garrison?.garrison_finalobservation ?? "";

    return (
        <>
            <InfoGrid title={title} items={initialData} />
            <div className="flex gap-4 px-5 mt-8">
                <ObservationBox title="Observação inicial">
                    {iniObservation}
                </ObservationBox>
                <ObservationBox title="Observação final">
                    {finObservation}
                </ObservationBox>
            </div>
        </>
    )
}